import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { CollectionCard } from 'legacyComponents/cards/types/collection';

@withNamespaces()
@inject('routerStore')
@observer
export class ChannelCollections extends React.Component {
  render() {
    const { collections } = this.props;

    return (
      <CardSection
        title='Collections'
        updateHeader
        index={3}
        isChannel
        ownerName=''
        cardApp={collections}
        CardComponent={CollectionCard}
        noDataCardType='collection'
        gridColumns={3}
      />
    );
  }
}

ChannelCollections.propTypes = {
  collections: PropTypes.object,
};
